module.exports = __webpack_public_path__ + "img/logoltong.5792b869.png";